"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const sample = require("lodash.sample");
const React = require("react");
const react_motion_1 = require("react-motion");
const LeadNotificationCard_1 = require("../LeadNotificationCard");
class LeadNotificationSystem extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            items: [],
        };
        this.getLeadNotificationItem = () => {
            const { names, locations, actions, times, ctaLink, ctaText, } = this.props.data;
            const name = sample(names);
            const location = sample(locations);
            const action = sample(actions);
            const time = sample(times);
            return {
                name,
                location,
                action,
                time,
                ctaLink,
                ctaText,
            };
        };
    }
    componentDidMount() {
        const { showTime, interval } = this.props.data;
        this.timeout = setInterval(() => {
            const item = this.getLeadNotificationItem();
            item.closeTime = date_fns_1.addMilliseconds(new Date(), showTime);
            this.setState({ items: [...this.state.items, item] });
        }, interval);
        this.closeNotificationTimeout = setInterval(() => {
            const nextItems = this.state.items.filter(x => {
                if (!x.closeTime) {
                    return true;
                }
                return date_fns_1.differenceInMilliseconds(x.closeTime, new Date()) > 0;
            });
            this.setState({ items: nextItems });
        }, 1000);
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
        clearTimeout(this.closeNotificationTimeout);
    }
    render() {
        const { items } = this.state;
        const item = items[0];
        return (React.createElement("div", { className: "fixed bottom-1 left-1" },
            React.createElement(react_motion_1.Motion, { defaultStyle: { x: 0 }, style: { x: react_motion_1.spring(item ? 0 : -300) } }, ({ x }) => (React.createElement("div", { style: {
                    transform: `translateX(${x}%)`,
                } }, item && React.createElement(LeadNotificationCard_1.default, { theme: this.props.theme, item: item }))))));
    }
}
exports.default = LeadNotificationSystem;
//# sourceMappingURL=index.js.map